import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { iconArrowsRight, iconMail, iconPhone } from '@knorr-bremse-portals/icons';
import { IconComponent as KBIconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';

const iconMap = {
  'link': iconArrowsRight,
  'phone': iconPhone,
  'mail': iconMail,
} as const;

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [KBIconComponent],
})
export class IconComponent {

  @Input() public icon!: keyof typeof iconMap;

  protected iconMap = iconMap;

}
